import { useState, useEffect, useCallback } from 'react';

const navLinks = [
  { name: '首页', href: '#hero' },
  { name: '平台介绍', href: '#about' },
  { name: '常见问答', href: '#faq' },
  { name: '焦点专题', href: '#carousel' },
  { name: '热门话题', href: '#topics' },
  { name: '联系我们', href: '#contact' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 60);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <a
            href="#hero"
            onClick={(e) => { e.preventDefault(); handleNavClick('#hero'); }}
            className="flex items-center gap-2 group cursor-pointer"
          >
            <span className={`font-heading text-xl md:text-2xl font-bold tracking-wide whitespace-nowrap transition-colors ${
              scrolled ? 'text-foreground-950' : 'text-white'
            }`}>
              51大赛
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                className={`relative px-3 py-2 text-sm font-medium rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  scrolled
                    ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-200'
                    : 'text-white/85 hover:text-white hover:bg-white/10'
                }`}
              >
                {link.name}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#ranking"
              onClick={(e) => { e.preventDefault(); handleNavClick('#ranking'); }}
              className={`px-5 py-2 text-sm font-semibold rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                scrolled
                  ? 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  : 'bg-white/15 text-white hover:bg-white/25 backdrop-blur-sm'
              }`}
            >
              热门榜单
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
              scrolled ? 'text-foreground-900 hover:bg-background-200' : 'text-white hover:bg-white/10'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden fixed inset-0 top-16 bg-background-50 z-40 overflow-y-auto">
          <nav className="flex flex-col px-4 py-6 gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                className="px-4 py-3 text-base font-medium text-foreground-800 hover:text-foreground-950 hover:bg-background-200 rounded-lg transition-colors cursor-pointer"
              >
                {link.name}
              </a>
            ))}
            <a
              href="#ranking"
              onClick={(e) => { e.preventDefault(); handleNavClick('#ranking'); }}
              className="mt-3 mx-4 px-5 py-3 text-center text-base font-semibold bg-primary-500 text-background-50 rounded-full cursor-pointer hover:bg-primary-600 transition-colors"
            >
              热门榜单
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}